export default "__VITE_ASSET__180314f2__"